/** Фильтр списка вопросов: node — UUID узла Libre; без него — все вопросы пользователя */
export class GetQuestionsParams {
  // declare: поле без значения не попадает в объект и в параметры запроса
  declare node?: string

  constructor({ node }: { node?: string }) {
    if (node !== undefined) {
      this.node = node
    }
  }
}
